<template>
  <div class="mt-10">
    <div class="lg:mt-10 md:mt-9 mt-5 lg:flex md:flex gap-2">
      <div class="container">
        <h2 class="fsize32 text4F0A4B text-left capitalize">
          <b>Symptoms</b>
        </h2>
        <p class="fsize16 text-dark mt-4">
          Dementia is a term used to describe a group of symptoms that affect
          memory, thinking, and social abilities. It is a condition that
          primarily affects older adults and can be caused by a variety of
          factors, including genetics, lifestyle factors, and underlying health
          conditions. As a caregiver, it is essential to be aware of the
          symptoms of dementia and understand how they can impact your loved
          one's daily life. <br />
          One of the most commonly recognized symptoms of dementia is memory
          loss. This can manifest as forgetting recent events or conversations,
          losing track of time, and struggling to remember important details
          such as names or addresses. Memory loss can be particularly
          distressing for both the person with dementia and their caregiver, as
          it can impact their ability to carry out daily activities and maintain
          independence. <br />
          Another common symptom of dementia is confusion. This can manifest as
          difficulty following instructions, becoming disoriented in familiar
          surroundings, or struggling to recognize people or objects. Confusion
          can be particularly challenging for caregivers, as it can lead to
          safety concerns such as wandering or getting lost. <br />
          Personality changes are also a common symptom of dementia. This can
          include changes in mood, behaviour, or social interaction. For
          example, a person with dementia may become more irritable, anxious, or
          withdrawn. They may also exhibit changes in their sense of humour or
          social interaction, becoming more disinhibited or uncharacteristically
          inappropriate in their behaviour. <br />
          As dementia progresses, other symptoms may emerge, including
          difficulty with language, problems with visual perception, and
          challenges with planning and decision-making. These symptoms can
          impact a person's ability to communicate, carry out daily activities,
          and maintain their quality of life.
        </p>
        <h2
          class="fsize24 lg:mt-10 md:mt-9 mt-5 mb-3 sm-fsize14 font-bold text4F0A4B"
        >
          Managing the Symptoms of Dementia
        </h2>
        <p class="fsize16 sm-fsize14 mb-4 text-dark">
          As a caregiver, it is important to be aware of these symptoms and
          understand how they can impact your loved one's daily life.
        </p>
        <div class="w-full lg:flex md:flex gap-4">
          <div class="lg:w-3/12 md:w-4/12 w-full">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/Symptoms%201.jpg"
              alt="cancer"
              class="tab_img1 object-cover"
            />
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/Symptoms%202.jpg"
              alt="cancer"
              class="tab_img2 object-cover"
            />
          </div>
          <div
            class="lg:w-9/12 md:w-8/12 w-full lg:mt-0 md:mt-0 mt-4 text-dark"
          >
            <ul class="list-dec">
              <li class="fsize16 pb-2">
                Promote a structured routine: Establishing a routine can help
                your loved one feel more comfortable and secure, reducing their
                risk of confusion or disorientation. Try to establish a regular
                schedule for meals, activities, and rest.
              </li>
              <li class="fsize16 pb-2">
                Simplify communication: As dementia progresses, your loved one
                may struggle with communication. Try to simplify your language
                and avoid using complex sentences or concepts. Use visual aids
                such as pictures or gestures to help convey meaning.
              </li>
              <li class="fsize16 pb-2">
                Promote social interaction: Social interaction can be
                particularly important for people with dementia, as it can help
                reduce feelings of isolation and promote cognitive stimulation.
                Try to encourage your loved one to participate in activities
                they enjoy, such as music, art, or exercise.
              </li>
              <li class="fsize16 pb-2">
                Practice patience and empathy: Caring for someone with dementia
                can be challenging, and it is important to practice patience and
                empathy. Try to understand your loved one's perspective and
                avoid becoming frustrated or angry.
              </li>
              <li class="fsize16 pb-2">
                Seek support: Caregiving for someone with dementia can be
                overwhelming, and it is important to seek support when needed.
                Consider joining a support group or seeking guidance from a
                healthcare professional.
              </li>
            </ul>
          </div>
        </div>
        <p class="fsize16 text-dark mt-8">
          At Caregiver Saathi, we understand the challenges of caring for
          someone with dementia. We offer a range of resources and support
          services for caregivers, including online forums, counseling services,
          and educational resources. Our goal is to help caregivers feel more
          confident and empowered in their caregiving role, and to provide a
          safe and supportive space for caregivers to connect with others who
          share their experiences.<br />
          In conclusion, dementia is a challenging condition that can impact
          many aspects of a person's daily life. As a caregiver, it is important
          to be aware of the symptoms of dementia and understand how they can
          impact your loved one's quality of life. By promoting structure,
          simplifying communication, encouraging social interaction, practicing
          patience and empathy, and seeking support, you can help your loved one
          manage the symptoms of dementia and maintain their independence and
          dignity. At Caregiver Saathi, we are here to support you every step of
        </p>
      </div>
      <!-- <div class="border-left lg:w-2/12 md:w-2/12 w-full lg:mt-0 md:mt-0 mt-4">
        <SideBlogs />
      </div> -->
    </div>
    <HealthcareProvider />
  </div>
</template>
<script>
import HealthcareProvider from "./components/HealthcareProvider.vue";
import SideBlogs from "./components/SideBlogs.vue";
export default {
  components: {
    HealthcareProvider,
    SideBlogs,
  },
};
</script>
<style>
.tab_img1 {
  border-radius: 40px 0px 0px 0px;
  height: 165px;
  width: 170px;
  margin: 12px 0 12px 0;
}
.tab_img2 {
  border-radius: 0px 0px 40px 0px;
  height: 165px;
  width: 170px;
}
.history2-img {
  border-radius: 40px 0px 40px 40px;
  height: 180px;
  width: 70%;
  margin: 40px 0px 0px auto;
}
.history3-img {
  border-radius: 40px 40px 0px 40px;
  height: 180px;
  width: 60%;
  margin: 40px auto 0px auto;
}
.history4-img {
  border-radius: 40px 40px 40px 0px;
  height: 180px;
  width: 60%;
  margin: 40px auto 0px auto;
}
.history5-img {
  border-radius: 0px 40px 40px 40px;
  height: 250px;
  width: 60%;
  margin: 40px auto 0px auto;
}
.history6-img {
  border-radius: 0px 40px 40px 40px;
  height: 180px;
  width: 60%;
  margin: 40px auto 0px auto;
}
@media (max-width: 640px) {
  .history-img {
    width: 100% !important;
  }
  .history2-img {
    width: 100% !important;
  }
  .history3-img {
    width: 100% !important;
  }
  .history4-img {
    width: 100% !important;
  }
  .history5-img {
    width: 100% !important;
  }
  .history6-img {
    width: 100% !important;
  }
}
.list-dec {
  list-style: decimal;
}
</style>
